import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { API_HOST } from "environments/environment"

@Injectable({
    providedIn: 'root'
})
export class TimesheetsApiService {

    constructor(private http: HttpClient) { }

    public create(data: any) {
        return this.http.post(API_HOST + 'timesheets', data)
    }

    public update(id: string, data: any) {
        return this.http.put(API_HOST + `timesheets/${id}`, data)
    }

    public delete(id: string) {
        return this.http.delete(API_HOST + `timesheets/${id}`)
    }

    public get(params: any) {
        return this.http.get(API_HOST + `timesheets?` + new URLSearchParams(params).toString())
    }

    public getById(id: string) {
        return this.http.get(API_HOST + `timesheets/${id}`)
    }

    public approve(id: string) {
        return this.http.patch(API_HOST + `timesheets/${id}/approve`, null)
    }

    public getDeleted(params: any) {
        return this.http.get(API_HOST + `timesheets/deleted?` + new URLSearchParams(params).toString())
    }

    public restore(id: string) {
        return this.http.patch(API_HOST + `timesheets/${id}/restore`, null)
    }

    public getModifiedUnreviewed() {
        return this.http.get(API_HOST + `timesheets/modified-unreviewed`)
    }

    public reviewModification(id: string) {
        return this.http.patch(API_HOST + `timesheets/${id}/review-modification`, null)
    }
}
